import { v4 } from "uuid";
import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { InsuranceCalculationBaseEnum, InsuranceEntity, TypologyEnum } from "../entity";

export function useFormData() {
  const formData = useForm<InsuranceEntity>({
    mode: "onBlur",
    defaultValues: {
      id: v4(),
      type: TypologyEnum.PERCENTAGE,
      calculationBase: InsuranceCalculationBaseEnum.ACCOMMODATION_AND_EXTRAS,
      ticker: "",
      active: true,
      taxes: [],
      fees: [],
      translationsList: [],
      typology: {
        percentage: { sectionsList: [{ amountFrom: 0, amountTo: 0, value: 0 }] },
      },
    },
  });

  return {
    update: useCallback((data: InsuranceEntity) => formData.reset(data), [formData]),
    methods: formData,
  };
}
